import createEnum from 'scripts/lib/create_enum';

export default createEnum('USD');
